import { Outlet } from 'react-router-dom';

export default function DefaultLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-ink-950 text-ink-50">
      <Outlet />
    </div>
  );
}
